import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess, staticc } from "../../Components/General/Notification";

const getCategories = (categories) => {
    return ({
        type: types.GET_ALL_CATEGORIES,
        payload: categories
    })
}

const addCategories = () => {
    return ({
        type: types.ADD_CATEGORIES
    })
}

const delCategories = () => {
    return ({
        type: types.DELETE_CATEGORIES
    })
}

const editstatusCat = () => {
    return ({
        type: types.EDIT_STATUS_CATEGORIES
    })
}

const editfeaturesCat = () => {
    return ({
        type: types.EDIT_FEATURES_CATEGORIES
    })
}
const editCat = () => {
    return ({
        type: types.EDIT_CATEGORY
    })
}

const getCategoryAds = (categoryAds) => {
    return ({
        type: types.GET_ALL_CATEGORIES_ADS,
        payload: categoryAds
    })
}

const addCategoryAds = () => {
    return ({
        type: types.ADD_CATEGORY_ADS
    })
}

const delCategoryAds = () => {
    return ({
        type: types.DELETE_CATEGORY_ADS
    })
}

const editstatusCatAds = () => {
    return ({
        type: types.EDIT_STATUS_CATEGORY_ADS
    })
}

const editCatAds = () => {
    return ({
        type: types.EDIT_CATEGORY_ADS
    })
}


export const loadCategories = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/categories`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getCategories(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const postCategory = (name, name_ar, description, description_ar, image, thumbnail, color, setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        let token = localStorage.getItem("tokenA");
        const Dataa = new FormData();
        Dataa.append('name', name);
        Dataa.append('name_ar', name_ar);
        Dataa.append('description', description);
        Dataa.append('description_ar', description_ar);
        Dataa.append('image', image);
        Dataa.append('thumbnail', thumbnail);
        Dataa.append('color', color);
        axios.post(`${staticc}/api/category_add`, Dataa, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(addCategories());
                dispatch(loadCategories());
                notifysuccess(res.data.message)
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}

export const updateCategory = (id, name, name_ar, description, description_ar, image, thumbnail, color, setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        let token = localStorage.getItem("tokenA");
        const Dataa = new FormData();
        console.log(thumbnail)
        if (image !== '') {
            Dataa.append('image', image);
        }
        if (thumbnail !== '') {
            console.log('in thumbnail')
            Dataa.append('thumbnail', thumbnail);
        }
        Dataa.append('id', id);
        Dataa.append('name', name);
        Dataa.append('name_ar', name_ar);
        Dataa.append('description', description);
        Dataa.append('description_ar', description_ar);
        Dataa.append('color', color);
        axios.post(`${staticc}/api/category_update`, Dataa, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(editCat());
                dispatch(loadCategories());
                notifysuccess(res.data.message)
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}

export const deleteCategory = (id) => {
    return function (dispatch) {
        //setloabBtn(true)
        console.log(id)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/category_delete`, { id }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(delCategories());
                dispatch(loadCategories());
                notifysuccess(res.data.message)
                //setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            //setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}

export const editStatusCategory = (id, is_active, setloadStatusID) => {
    return function (dispatch) {
        setloadStatusID(true)
        console.log(id)
        console.log(is_active)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/category_status`, { id, is_active }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(editstatusCat());
                dispatch(loadCategories());
                notifysuccess(res.data.message)
                setloadStatusID(false)
            }
        }).catch((err) => {
            console.log(err)
            setloadStatusID(false)
            notifyError(err.response.data)
        })
    }
}

export const editFeaturesCategory = (id, featured, setloadFeaturesID) => {
    return function (dispatch) {
        setloadFeaturesID(true)
        console.log(id)
        console.log(featured)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/category_featured`, { id, featured }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(editfeaturesCat());
                dispatch(loadCategories());
                notifysuccess(res.data.message)
                setloadFeaturesID(false)
            }
        }).catch((err) => {
            console.log(err)
            setloadFeaturesID(false)
            notifyError(err.response.data)
        })
    }
}

export const loadCategoryAds = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/categoryAds`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getCategoryAds(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const postCategoryAds = (category_id, start_date, end_date, url, is_active, image, priority, setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        let token = localStorage.getItem("tokenA");
        const Dataa = new FormData();
        Dataa.append('category_id', category_id);
        Dataa.append('start_date', start_date);
        Dataa.append('end_date', end_date);
        Dataa.append('url', url);
        Dataa.append('image', image);
        Dataa.append('priority', priority);
        Dataa.append('is_active', is_active);
        axios.post(`${staticc}/api/categoryAd-store`, Dataa, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(addCategoryAds());
                dispatch(loadCategoryAds());
                notifysuccess(res.data.message)
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}


export const deleteCategoryAds = (id) => {
    return function (dispatch) {
        console.log(id)
        let token = localStorage.getItem("tokenA");
        axios.delete(`${staticc}/api/categoryAd-delete?id=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(delCategoryAds());
                dispatch(loadCategoryAds());
                notifysuccess(res.data.message)
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const editStatusCategoryAds = (id, is_active, setloadStatusID) => {
    return function (dispatch) {
        setloadStatusID(true)
        console.log(id)
        console.log(is_active)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/categoryAd-update-status`, { id, is_active }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(editstatusCatAds());
                dispatch(loadCategoryAds());
                notifysuccess(res.data.message)
                setloadStatusID(false)
            }
        }).catch((err) => {
            console.log(err)
            setloadStatusID(false)
            notifyError(err.response.data)
        })
    }
}

export const updateCategoryAds = (id, category_id, start_date, end_date, url, is_active, image, priority, setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        console.log("--------------")
        console.log(id)
        console.log(image)
        console.log("--------------")
        let token = localStorage.getItem("tokenA");
        const Dataa = new FormData();
        if (image !== '') {
            Dataa.append('image', image);
        }
        Dataa.append('id', id);
        Dataa.append('category_id', category_id);
        Dataa.append('start_date', start_date);
        Dataa.append('end_date', end_date);
        Dataa.append('url', url);
        Dataa.append('priority', priority);
        Dataa.append('is_active', is_active);
        axios.post(`${staticc}/api/categoryAd-update`, Dataa, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(editCatAds());
                dispatch(loadCategoryAds());
                notifysuccess(res.data.message)
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}
